var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{ref:"cav",staticClass:"canvas",on:{"click":_vm.Refresh}})}
var staticRenderFns = []

export { render, staticRenderFns }